<template>

        <!-- Modal -->
        <div class="modal fade"  :class="{ show: false, 'd-block': false }"  id="evangelism_typeModal"    aria-labelledby="evangelism_typeModalLabel" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-lg" style="max-height:30%; max-width: 80%;" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="evangelism_typeModalLabel" v-if="evangelism_type_view_type=='add'">Add Evangelism Type</h5>
                <h5 class="modal-title" id="evangelism_typeModalLabel" v-else-if="evangelism_type_view_type=='edit'">Edit Evangelism Type</h5>
                <h5 class="modal-title" id="evangelism_typeModalLabel" v-else-if="evangelism_type_view_type=='view'">View Evangelism Type</h5>
                <button type="button" class="btn-close" :data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#evangelism_typeModal" aria-label="Close"></button>
            </div>
              <div v-if="this.evangelism_type_view_type=='add' || this.evangelism_type_view_type=='edit'">
              <form class="register-form" @submit.prevent="reg()">
            <div class="modal-body">

                <div class="card shadow-sm" id="stylized">
                   
                                <!-- <div class="card-body"> -->


                    <div class="card-body">
                      <h1 v-if="evangelism_type_view_type == 'add'">Add Evangelism Type</h1>
                      <h1 v-else-if="evangelism_type_view_type == 'edit'">Edit Evangelism Type</h1>
                      <br/>
                      <p></p>
        
                  <span>
                  
           




                      <div class="row">

                <div class="col">
                        <label>Evangelism Type</label>
                        <div class="input-group">
                          

                          <input
                            type="text"
                            class="form-control"
                            :class="{ form_error: evangelism_typeErr}"
                            placeholder="Evangelism Type"
                            @blur="evangelism_typeVal($event.target.value)" 
                            v-model.trim="formData.evangelism_type"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: evangelism_typeErr  }"
                           v-if="evangelism_typeErr">
                          {{ evangelism_typeErr }} 
                          </div>
                      </div>






                        






                     <div class="col">
                              <label>Is Active</label>
                            <div class="input-group">
                          
                          <select
                            class="form-control"
                            :class="{ form_error: is_activeErr}"
                             @change="is_activeVal($event.target.value)"
                            v-model.trim="formData.is_active">
                            <option value="">--Choose An Option--</option>
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                          </select>
                          
                          
                        </div>
                        <div
                            :class="{ text_error: is_activeErr}"
                            v-if="is_activeErr"
                          >
                            {{ is_activeErr }}
                          </div>
                      </div>

         



                     




                    </div>



                    <div class="row">


                     <div class="col">
                        <label>From Date</label>
                        <div class="input-group">
                          

                          <input
                            type="date"
                            class="form-control"
                            :class="{ form_error: from_dateErr}"
                            placeholder="From Date"
                            @blur="from_dateVal($event.target.value)" 
                            v-model.trim="formData.from_date"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: from_dateErr  }"
                           v-if="from_dateErr">
                          {{ from_dateErr }} 
                          </div>
                      </div>







                           <div class="col">
                        <label>To Date</label>
                        <div class="input-group">
                          

                          <input
                            type="date"
                            class="form-control"
                            :class="{ form_error: to_dateErr}"
                            placeholder="To Date"
                            @blur="to_dateVal($event.target.value)" 
                            v-model.trim="formData.to_date"
                          />
                         
                        </div>
                         <div
                            :class="{ text_error: to_dateErr  }"
                           v-if="to_dateErr">
                          {{ to_dateErr }} 
                          </div>
                      </div>


                    </div>



                  </span>
                    </div>



                    

                                </div>
                
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" v-if="evangelism_type_view_type=='add'">Submit</button>
                <button type="submit" class="btn btn-primary" v-if="evangelism_type_view_type=='edit'">Update</button>
                <button type="button" class="btn btn-danger" @click="remove_all" v-if="evangelism_type_view_type=='add'">Clear All</button>
                <button type="button" class="btn btn-secondary" ref="evangelism_type_modal_ref" data-bs-dismiss="modal" v-if="evangelism_type_view_type=='edit'">Close</button>
            </div>

                  </form>
                  </div>


                 <div v-else>
                      <div class="modal-body">
                        <div class="table-responsive table-responsive-data2">
                        <table class="table table-hover table-striped">
                          
                              <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Value</th>
                                </tr>
                                </thead>


                                <tbody>
                                <tr>
                                <td>Evangelism Type</td>
                                <td>{{formData.evangelism_type}}</td>
                                </tr>


                                <tr>
                                <td>From Date</td>
                                <td>{{formData.from_date}}</td>
                                </tr>



                                <tr>
                                <td>To Date</td>
                                <td>{{formData.to_date}}</td>
                                </tr>


                               <tr>
                                <td>Is Active</td>
                                <td>{{formData.is_active}}</td>
                                </tr>




                 
                              </tbody>
                                  </table>









                                                                

                    
                        </div>

                      </div>

                 </div>


            </div>
        </div>


        
        </div>
</template>

<script>
 import axios from 'axios';
import FieldValidateService from "@/services/FieldValidateService";
import notificationBox from "@/services/notificationBox";
//import SpinnerComp from "@/components/SpinnerComp.vue";
import { mapActions, mapMutations } from 'vuex';
import { DEPENDENT_LINK_REG, EDIT_DEPENDENT_LINK_REG, LOADING, RESET_DEPENDENT_SEARCH_RESULT, SEARCH_DEPENDENT } from '@/store/storeconstants';
//import VueMultiselect from 'vue-multiselect'
//import Select2 from 'vue3-select2-component';
//import vSelect from 'vue-select'

    export default {

        name:'EvangelismTypeModals',
        props:{
            evangelism_type_view_type:{
                required:true,
            },

            evangelism_type_data:{
                required:true,
            }
        },


           mounted(){

              this.showLoading(false);

           },

         created() {

  
                this.showLoading(true);
                this.getPortal();
                console.log(this.formData.church_id);

 

        },




         data: function () {
    return {
      //userModal: null,
      link_val:"",
      app_portal: "",
      loading:false,
      errorMess: "",
      succMess:"",
      clear_user: true,
      clear_all: true,
      errorClient:[],
      errorServers:[],
       modal:"modal",


   
      

      formData: {
        portal:"",
        evangelism_type_id:"",

        evangelism_type: "",
        from_date: "",
        to_date: "",
        is_active: "",
        view_type:"",
        church_id:"",
        church:""
        
        
      },



    //Errors  
      evangelism_typeErr: "",
      is_activeErr: "",
      from_dateErr: "",
      to_dateErr: "",






    };
  },


      methods: {

          ...mapActions({
            search_dependent: 'dependent/'+SEARCH_DEPENDENT,
            link_dependent_support: 'dependent/'+DEPENDENT_LINK_REG,
            edit_link_dependent_support:'dependent/'+EDIT_DEPENDENT_LINK_REG
          }),




         ...mapMutations({
                 reset_dependent_search_result: 'dependent/'+RESET_DEPENDENT_SEARCH_RESULT,
                 showLoading:LOADING,
         }),







       async reg(){
      
      //notificationBox.successAlert("Registration Successful","An Email Has Been Sent To You. Please Click On The Link To Verify Your Account") 
       //console.log(this.formData);
       // console.log(this.errorClient);
        this.errorServers = [];
       this.errorClient = [];
       this.showLoading(true);

        this.evangelism_typeVal(this.formData.evangelism_type);
        this.is_activeVal(this.formData.is_active);
        this.from_dateVal(this.formData.from_date);
        this.to_dateVal(this.formData.to_date);




   

             if(this.errorClient.length > 0)
       {
         this.showLoading(false);
          notificationBox.errorNotifications("Some Errors Exist");
          console.log(this.errorClient);
          return true;
       }

   




    if(this.evangelism_type_view_type=="add"){


         try{
            const response = await axios.post("evangelism_types",this.formData);
              if(response.status == 200)
              {
                   this.showLoading(false);

                     this.clearFormData();
        notificationBox.succNotifications("Evangelism Type Added Successfully");
        this.$emit("evangelism_typeAdded");
              }


         }catch(error){

                 //console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);


               if(error.response.data.data_error)
       {
        notificationBox.errorNotifications(error.response.data.data_error);
       }
          

                  else if(this.errorServers.length > 0)
       {
           notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
    

         }
 



    }
    else if(this.evangelism_type_view_type=="edit")
    {





         try{
            const response = await axios.patch(`evangelism_types/${this.formData.evangelism_type_id}`,this.formData);
              if(response.status == 200)
              {

                     this.showLoading(false);
                     this.$refs.evangelism_type_modal_ref.click();
                     this.clearFormData();
        notificationBox.succNotifications("Evangelism Type Edited Successfully");
        this.$emit("evangelism_typeAdded");
              }


         }catch(error){

                // console.log(error);
           this.errorServers.push(error.response.data.error);
           
           this.showLoading(false);
        

          
               if(error.response.data.data_error)
       {
        notificationBox.errorNotifications(error.response.data.data_error);
       }
          

           else  if(this.errorServers.length > 0)
       {
             notificationBox.errorNotifications("Some Errors Exist");
            this.getServerError();
     
       }
     

         }
     

           


    }




    
    },





     clearFormData(){
        this.errorServers = [];
        this.errorClient = [];
      //this.clear_user = false;
      this.formData.evangelism_type = "";
      this.formData.evangelism_type_id = "";
      this.formData.from_date = "";
      this.formData.to_date = "";
      this.formData.is_active = "";
      this.evangelism_typeErr = "";
      this.is_activeErr = "";

      this.getPortal();

    },




   getServerError(){

       this.evangelism_typeErr = 'evangelism_type' in this.errorServers[0] ? this.errorServers[0].evangelism_type[0] : '';
      this.is_activeErr = 'is_active' in this.errorServers[0] ? this.errorServers[0].is_active[0] : '';
      this.from_dateErr = 'from_date' in this.errorServers[0] ? this.errorServers[0].from_date[0] : '';
      this.to_dateErr = 'to_date' in this.errorServers[0] ? this.errorServers[0].to_date[0] : '';


     
           return true;

   },





     evangelism_typeVal(value){

      let max = 500;
      let field = "Evangelism Type"

         if(FieldValidateService.reqMaxStringVal(value, field,max))
     {
       this.evangelism_typeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.evangelism_typeErr);
     }else{

           this.evangelism_typeErr =""; 
          this.errorClient.pop(this.evangelism_typeErr);

     }


    },







     is_activeVal(value) {

      let max = 10;
      let field = "Is Active";
     
     if(FieldValidateService.reqMaxStringVal(value,field,max))
     {
       this.is_activeErr = FieldValidateService.reqMaxStringVal(value,field,max);
        this.errorClient.push(this.is_activeErr);
     }else{

           if(this.errorClient.includes(this.is_activeErr))
           {
            let pos = this.errorClient.indexOf(this.is_activeErr);
           this.errorClient.splice(pos,1);
            this.is_activeErr =""; 
           }
          
          

     }
    },









     from_dateVal(value) {

      let field = "From Date";
     
     if(FieldValidateService.reqVal(value,field))
     {
       this.from_dateErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.from_dateErr);
     }else{

           if(this.errorClient.includes(this.from_dateErr))
           {
            let pos = this.errorClient.indexOf(this.from_dateErr);
           this.errorClient.splice(pos,1);
            this.from_dateErr =""; 
           }
          
          

     }
    },







         to_dateVal(value) {

      let field = "To Date";
     
     if(FieldValidateService.reqVal(value,field))
     {
       this.to_dateErr = FieldValidateService.reqVal(value,field);
        this.errorClient.push(this.to_dateErr);
     }else{

           if(this.errorClient.includes(this.to_dateErr))
           {
            let pos = this.errorClient.indexOf(this.to_dateErr);
           this.errorClient.splice(pos,1);
            this.to_dateErr =""; 
           }
          
          

     }
    },





        getPortal(){


 
if(Array.isArray(JSON.parse(localStorage.getItem("user_portal_info")))) {
   this.app_portal = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal;
 if(this.app_portal == "CHURCH")
 {

this.formData.church_id = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church_id;
this.formData.church = JSON.parse(localStorage.getItem("user_portal_info"))[0].portal_church;
 }
 
}
else{


     this.app_portal = JSON.parse(localStorage.getItem("user_portal_info")).portal;
 if(this.app_portal == "CHURCH")
 {
this.formData.church_id = JSON.parse(localStorage.getItem("user_portal_info")).portal_church_id;
this.formData.church = JSON.parse(localStorage.getItem("user_portal_info")).portal_church;
 }
 

}
        }




    




      





  

      },

      
  computed:{


    // ...mapState('dependent',['dependent_view_type','dependent_info','search_message','search_dependent_result']),
    // ...mapState('dependent_support',['dependent_support_view_type','dependent_support_info']),

    // firstName(){
    //   return this.checked_user_data.fullname;
    // }
  },  

    components: {
      //SpinnerComp,
      //vSelect
      //VueMultiselect
     // Select2
    },

    watch:{

 


   




        evangelism_type_view_type(value){
          console.log(value);
           if(value == "add"){
        
           this.clearFormData();
           


           }
        },

        evangelism_type_data(value){
       
         let data = value;
         console.log(value);
            //console.log(data);
            //this.clearFormData();
            this.formData.evangelism_type_id = data.id;
            this.formData.evangelism_type = data.evangelism_type;
            this.formData.from_date = data.from_date;
            this.formData.to_date = data.to_date;
            this.formData.church_id = data.church_id;
            this.formData.is_active = data.is_active;
        
       
          
          
        },







    



    }
        
    }
</script>

<style scoped>


</style>